module.exports = [
  {
    "id": "Pacific/Majuro",
    "offset": "-12:00"
  },
  {
    "id": "Pacific/Pago_Pago",
    "offset": "-11:00"
  },
  {
    "id": "America/Adak",
    "offset": "-10:00"
  },
  {
    "id": "Pacific/Honolulu",
    "offset": "-10:00"
  },
  {
    "id": "Pacific/Marquesas",
    "offset": "-10:30"
  },
  {
    "id": "Pacific/Gambier",
    "offset": "-9:00"
  },
  {
    "id": "America/Anchorage",
    "offset": "-9:00"
  },
  {
    "id": "America/Los_Angeles",
    "offset": "-8:00"
  },
  {
    "id": "Pacific/Pitcairn",
    "offset": "-8:00"
  },
  {
    "id": "America/Phoenix",
    "offset": "-7:00"
  },
  {
    "id": "America/Denver",
    "offset": "-7:00"
  },
  {
    "id": "America/Guatemala",
    "offset": "-6:00"
  },
  {
    "id": "America/Chicago",
    "offset": "-6:00"
  },
  {
    "id": "Pacific/Easter",
    "offset": "-6:00"
  },
  {
    "id": "America/Bogota",
    "offset": "-5:00"
  },
  {
    "id": "America/New_York",
    "offset": "-5:00"
  },
  {
    "id": "America/Caracas",
    "offset": "-5:30"
  },
  {
    "id": "America/Halifax",
    "offset": "-4:00"
  },
  {
    "id": "America/Santo_Domingo",
    "offset": "-4:00"
  },
  {
    "id": "America/Santiago",
    "offset": "-4:00"
  },
  {
    "id": "America/St_Johns",
    "offset": "-4:30"
  },
  {
    "id": "America/Godthab",
    "offset": "-3:00"
  },
  {
    "id": "America/Argentina/Buenos_Aires",
    "offset": "-3:00"
  },
  {
    "id": "America/Montevideo",
    "offset": "-3:00"
  },
  {
    "id": "America/Noronha",
    "offset": "-2:00"
  },
  {
    "id": "Atlantic/Azores",
    "offset": "-1:00"
  },
  {
    "id": "Atlantic/Cape_Verde",
    "offset": "-1:00"
  },
  {
    "id": "Etc/UTC",
    "offset": "+0:00"
  },
  {
    "id": "Europe/London",
    "offset": "+0:00"
  },
  {
    "id": "Europe/Berlin",
    "offset": "+1:00"
  },
  {
    "id": "Africa/Lagos",
    "offset": "+1:00"
  },
  {
    "id": "Africa/Windhoek",
    "offset": "+1:00"
  },
  {
    "id": "Asia/Beirut",
    "offset": "+2:00"
  },
  {
    "id": "Africa/Johannesburg",
    "offset": "+2:00"
  },
  {
    "id": "Asia/Baghdad",
    "offset": "+3:00"
  },
  {
    "id": "Europe/Moscow",
    "offset": "+3:00"
  },
  {
    "id": "Asia/Tehran",
    "offset": "+3:30"
  },
  {
    "id": "Asia/Dubai",
    "offset": "+4:00"
  },
  {
    "id": "Asia/Baku",
    "offset": "+4:00"
  },
  {
    "id": "Asia/Kabul",
    "offset": "+4:30"
  },
  {
    "id": "Asia/Yekaterinburg",
    "offset": "+5:00"
  },
  {
    "id": "Asia/Karachi",
    "offset": "+5:00"
  },
  {
    "id": "Asia/Kolkata",
    "offset": "+5:30"
  },
  {
    "id": "Asia/Kathmandu",
    "offset": "+5:45"
  },
  {
    "id": "Asia/Dhaka",
    "offset": "+6:00"
  },
  {
    "id": "Asia/Omsk",
    "offset": "+6:00"
  },
  {
    "id": "Asia/Rangoon",
    "offset": "+6:30"
  },
  {
    "id": "Asia/Krasnoyarsk",
    "offset": "+7:00"
  },
  {
    "id": "Asia/Jakarta",
    "offset": "+7:00"
  },
  {
    "id": "Asia/Shanghai",
    "offset": "+8:00"
  },
  {
    "id": "Asia/Irkutsk",
    "offset": "+8:00"
  },
  {
    "id": "Australia/Eucla",
    "offset": "+8:45"
  },
  {
    "id": "Asia/Yakutsk",
    "offset": "+9:00"
  },
  {
    "id": "Asia/Seoul",
    "offset": "+9:00"
  },
  {
    "id": "Asia/Tokyo",
    "offset": "+9:00"
  },
  {
    "id": "Australia/Darwin",
    "offset": "+9:30"
  },
  {
    "id": "Australia/Adelaide",
    "offset": "+9:30"
  },
  {
    "id": "Australia/Brisbane",
    "offset": "+10:00"
  },
  {
    "id": "Asia/Vladivostok",
    "offset": "+10:00"
  },
  {
    "id": "Australia/Sydney",
    "offset": "+10:00"
  },
  {
    "id": "Australia/Lord_Howe",
    "offset": "+10:30"
  },
  {
    "id": "Asia/Kamchatka",
    "offset": "+11:00"
  },
  {
    "id": "Pacific/Noumea",
    "offset": "+11:00"
  },
  {
    "id": "Pacific/Norfolk",
    "offset": "+11:30"
  },
  {
    "id": "Pacific/Auckland",
    "offset": "+12:00"
  },
  {
    "id": "Pacific/Tarawa",
    "offset": "+12:00"
  },
  {
    "id": "Pacific/Chatham",
    "offset": "+12:45"
  },
  {
    "id": "Pacific/Tongatapu",
    "offset": "+13:00"
  },
  {
    "id": "Pacific/Apia",
    "offset": "+13:00"
  },
  {
    "id": "Pacific/Kiritimati",
    "offset": "+14:00"
  }
];